__turbopack_context__.v({
  "auFieldFill": "DvQYTa_auFieldFill",
  "boardIndent": "DvQYTa_boardIndent",
  "boardName": "DvQYTa_boardName",
  "boardNameCard": "DvQYTa_boardNameCard",
  "boardNameHero": "DvQYTa_boardNameHero",
  "boardNameText": "DvQYTa_boardNameText",
  "boardNr": "DvQYTa_boardNr",
  "colHead": "DvQYTa_colHead",
  "colHeadLeft": "DvQYTa_colHeadLeft",
  "colHeadRight": "DvQYTa_colHeadRight",
  "colLabel": "DvQYTa_colLabel",
  "columnLabel": "DvQYTa_columnLabel",
  "columnLabelRow": "DvQYTa_columnLabelRow",
  "columnLabelText": "DvQYTa_columnLabelText",
  "field": "DvQYTa_field",
  "fieldFilled": "DvQYTa_fieldFilled",
  "fieldLabel": "DvQYTa_fieldLabel",
  "fieldLabelRoomy": "DvQYTa_fieldLabelRoomy",
  "fieldRoomy": "DvQYTa_fieldRoomy",
  "header": "DvQYTa_header",
  "headerCard": "DvQYTa_headerCard",
  "headerDetail": "DvQYTa_headerDetail",
  "headerHero": "DvQYTa_headerHero",
  "headerLeading": "DvQYTa_headerLeading",
  "headerRight": "DvQYTa_headerRight",
  "headerSlash": "DvQYTa_headerSlash",
  "headerTitle": "DvQYTa_headerTitle",
  "pill": "DvQYTa_pill",
  "pillCard": "DvQYTa_pillCard",
  "pillDashed": "DvQYTa_pillDashed",
  "pillEmpty": "DvQYTa_pillEmpty",
  "pillHero": "DvQYTa_pillHero",
  "pillRinged": "DvQYTa_pillRinged",
  "root": "DvQYTa_root",
  "stat": "DvQYTa_stat",
  "statLabel": "DvQYTa_statLabel",
  "statValue": "DvQYTa_statValue",
  "statusBadge": "DvQYTa_statusBadge",
  "statusBadgeOutlined": "DvQYTa_statusBadgeOutlined",
  "subHeader": "DvQYTa_subHeader",
  "subHeaderCard": "DvQYTa_subHeaderCard",
  "subHeaderHero": "DvQYTa_subHeaderHero",
  "subHeaderRowLabel": "DvQYTa_subHeaderRowLabel",
  "subHeaderTracked": "DvQYTa_subHeaderTracked",
  "tag": "DvQYTa_tag",
  "track": "DvQYTa_track",
  "trackFill": "DvQYTa_trackFill",
});
